import { render } from "./TheNav.vue?vue&type=template&id=7ace54ce"
import script from "./TheNav.vue?vue&type=script&lang=js"
export * from "./TheNav.vue?vue&type=script&lang=js"

import exportComponent from "C:\\eikainteriors\\eikainteriors\\frontend\\eikaiinteriors\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__